export default class TRAINMemberProfile {

    public static memberProfileFromAPI(member: any): TRAINMemberProfile {
        const memberProfile: TRAINMemberProfile = new TRAINMemberProfile();
        memberProfile.setAllFields(member);
        return memberProfile;
    }

    public ubcId?: string;
    public firstName?: string;
    public middleName?: string;
    public lastName?: string;
    public suffix?: string;
    public affiliateId?: number;
    public emergencyContactName?: string;
    public emergencyContactRelationship?: string;
    public emergencyContactDayPhoneNumber?: string;
    public emergencyContactDayPhoneNumberExt?: string;
    public emergencyContactNightPhoneNumber?: string;
    public emergencyContactNightPhoneNumberExt?: string;

    protected setAllFields(member: any) {
        this.ubcId = member.ubcId;
        this.firstName = member.firstName;
        this.middleName = member.middleName;
        this.lastName = member.lastName;
        this.suffix = member.suffix;
        this.affiliateId = member.affiliateId;
        this.emergencyContactName = member.emergencyContactName;
        this.emergencyContactRelationship = member.emergencyContactRelationship;
        if (member.emergencyContactDayPhoneNumber) {
            this.emergencyContactDayPhoneNumber = member.emergencyContactDayPhoneNumber;
        }
        if (member.emergencyContactDayPhoneNumberExt) {
            this.emergencyContactDayPhoneNumberExt = member.emergencyContactDayPhoneNumberExt;
        }
        if (member.emergencyContactNightPhoneNumber) {
            this.emergencyContactNightPhoneNumber = member.emergencyContactNightPhoneNumber;
        }
        if (member.emergencyContactNightPhoneNumberExt) {
            this.emergencyContactNightPhoneNumberExt = member.emergencyContactNightPhoneNumberExt;
        }
    }
}
